/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui';
// import { hoverTransition } from '../../../utils/styles/general';



/* ++++++++++ --------------- LINK CONTROLS : STYLES --------------- ++++++++++ */
export default {
    linkcontrols: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        margin: pxToEm(24), 
        '& > .tooltip': {
            '& > div': {
                display: 'flex !important'
            }
        }
    }
};
